import { useCallback } from 'react';
import { useNavigate, useParams } from '@tanstack/react-router';

export function useGoHome({ preserveClub }: { preserveClub: boolean }) {
  const { clubId } = useParams({ strict: false });
  const navigate = useNavigate();

  const goHome = useCallback(() => {
    if (!clubId || !preserveClub) {
      return navigate({
        from: '/',
        to: '/',
      });
    }

    return navigate({
      from: '/',
      to: '/club/$clubId',
      params: { clubId },
    });
  }, [clubId, navigate, preserveClub]);

  return goHome;
}
